const EventKeys = {
  TurnNextHero: 'turn-next-hero',
};

export default EventKeys;
